var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnPremise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50145 0.538066C8.76833 -0.0953707 10.2595 -0.0953711 11.5264 0.538066L18.5139 4.03184V14.0668C18.5139 17.5318 15.3109 19.8708 9.51392 23.5318C3.71692 19.8708 0.513916 16.7818 0.513916 14.0668V4.03184L7.50145 0.538066ZM11.764 10.0634C11.764 10.9887 11.2612 11.7967 10.514 12.2289V16.3126C10.514 17.0029 9.95431 17.5626 9.26396 17.5626C8.5736 17.5626 8.01396 17.0029 8.01396 16.3126V12.2289C7.26671 11.7967 6.76397 10.9887 6.76397 10.0634C6.76397 8.68268 7.88326 7.56339 9.26397 7.56339C10.6447 7.56339 11.764 8.68268 11.764 10.0634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnPremise);
export default __webpack_public_path__ + "static/media/on-premise.32b8edfb80db8a9196078147d4ff5f72.svg";
export { ForwardRef as ReactComponent };